import "./Job.css";

import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { requestGetBoardJobs } from "../../services/wisdomServices/jobServices";

function Job() {
  const applicantSigninUrl = `${globalThis.location.origin}/applicant-signin`;
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [loadingJob, setLoadingJob] = useState(true);
  const [jobError, setJobError] = useState(false);

  useEffect(() => {
    const loadJobDetails = async () => {
      try {
        setLoadingJob(true);
        setJobError(false);

        const response = await requestGetBoardJobs(1, 1, uuid);
        setJob(response.data[0]);
      } catch (error) {
        console.error("Error loading job details:", error);
        setJobError(true);
      } finally {
        setLoadingJob(false);
      }
    };

    if (uuid) {
      loadJobDetails();
    } else {
      setLoadingJob(false);
      setJobError(true);
    }
  }, [uuid]);

  const parseList = (value) => {
    if (!value) return [];

    return String(value)
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  };

  const handleBackToJobList = () => {
    navigate("/open-jobs");
  };

  const BackToJobListButton = () => (
    <div className="job-page-actions">
      <Button
        type="button"
        label="Back to job list"
        icon="pi pi-arrow-left"
        outlined
        onClick={handleBackToJobList}
      />
    </div>
  );

  const DetailItem = ({ label, value }) => (
    <div className="job-page-detail-item">
      <span className="job-page-detail-label">{label}</span>

      <p className="job-page-detail-value">
        {value || "Not informed"}
      </p>
    </div>
  );

  const DetailList = ({ label, items }) => (
    <div className="job-page-detail-item">
      <span className="job-page-detail-label">{label}</span>

      {items.length > 0 ? (
        <div className="job-page-tags">
          {items.map((item) => (
            <span key={item} className="job-page-tag">
              {item}
            </span>
          ))}
        </div>
      ) : (
        <p className="job-page-detail-value">Not informed</p>
      )}
    </div>
  );

  const JobSkeleton = () => (
    <div className="job-page-details">
      <section className="job-page-section job-page-skeleton">
        <Skeleton width="50%" height="28px" className="mb-4" />

        <Skeleton width="25%" height="14px" className="mb-2" />
        <Skeleton width="100%" height="20px" className="mb-2" />
        <Skeleton width="90%" height="20px" className="mb-4" />

        <Skeleton width="20%" height="14px" className="mb-2" />
        <Skeleton width="35%" height="20px" className="mb-4" />

        <Skeleton width="20%" height="14px" className="mb-2" />
        <Skeleton width="45%" height="20px" className="mb-4" />

        <Skeleton width="15%" height="14px" className="mb-2" />

        <div className="job-page-skeleton-tags">
          <Skeleton
            width="90px"
            height="30px"
            borderRadius="999px"
          />

          <Skeleton
            width="110px"
            height="30px"
            borderRadius="999px"
          />

          <Skeleton
            width="80px"
            height="30px"
            borderRadius="999px"
          />
        </div>

        <Skeleton
          width="20%"
          height="14px"
          className="mt-4 mb-2"
        />

        <div className="job-page-skeleton-tags">
          <Skeleton
            width="100px"
            height="30px"
            borderRadius="999px"
          />

          <Skeleton
            width="90px"
            height="30px"
            borderRadius="999px"
          />
        </div>

        <Skeleton
          width="25%"
          height="14px"
          className="mt-4 mb-2"
        />

        <Skeleton
          width="100%"
          height="20px"
          className="mb-2"
        />

        <Skeleton width="85%" height="20px" />
      </section>
    </div>
  );

  if (loadingJob) {
    return (
      <main className="job-page">
        <div className="job-page-container">
          <BackToJobListButton />

          <JobSkeleton />
        </div>
      </main>
    );
  }

  if (jobError || !job) {
    return (
      <main className="job-page">
        <header className="open-jobs-header">
          <BackToJobListButton />
          <div className="open-jobs-header-title">
            <h1>Find Your Next <br /> Great Opportunity</h1>
            <p>Discover roles that match your skills and aspirations. <br />Apply in minutes and start your journey with us.</p>
          </div>
        </header>
        <div className="job-page-container">

          <div className="job-page-error">
            <h2>Job not found</h2>

            <p>
              We could not load the requested job opportunity.
            </p>
          </div>
        </div>
      </main>
    );
  }

  const skills = parseList(job.skills);
  const languages = parseList(job.languages);

  return (
    <main className="job-page">
      <header className="open-jobs-header">
        <BackToJobListButton />
        <div className="open-jobs-header-title">
          <h1>Find Your Next <br /> Great Opportunity</h1>
          <p>Discover roles that match your skills and aspirations. <br />Apply in minutes and start your journey with us.</p>
        </div>
      </header>
      <div className="job-page-container">

        <div className="job-page-details">
          <section className="job-page-section">
            <h1>{job.jobTitle || "Job Opportunity"}</h1>

            <DetailItem
              label="Job Description"
              value={job.jobDescription}
            />

            <DetailItem
              label="Offer Rate"
              value={job.offerRate}
            />

            <DetailItem
              label="Location"
              value={job.location}
            />

            <DetailList
              label="Skills"
              items={skills}
            />

            <DetailList
              label="Languages"
              items={languages}
            />

            <DetailItem
              label="Responsibilities"
              value={job.responsibilities}
            />

            <DetailItem
              label="Requirements"
              value={job.requirements}
            />
          </section>
        </div>
        <div className="job-offer-apply-btn">
          <Button
          label="Apply now"
          onClick={() =>
              window.open(applicantSigninUrl, "_blank", "noopener,noreferrer")
          }
          />
        </div>
      </div>
    </main>
  );
}

export default Job;